import { render, staticRenderFns } from "./main.vue?vue&type=template&id=38650820&scoped=true"
import script from "./main.vue?vue&type=script&lang=ts"
export * from "./main.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38650820",
  null
  
)

export default component.exports